var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('edit-subscription-popup', {
    attrs: {
      "subscription-to-edit": _vm.subscriptionToEdit,
      "data-to-show": _vm.isPopupEditSubscriptionDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateEditSubscriptionPopup(false);
      }
    }
  }), _vm._v(" "), _c('edit-administrateur-payeur-popup', {
    attrs: {
      "admin-to-edit": _vm.adminToEdit,
      "data-to-show": _vm.isPopupEditAdministrateurPayeurDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateEditAdministrateurPayeurPopup(false);
      }
    }
  }), _vm._v(" "), _c('list-accounts-to-connect', {
    attrs: {
      "data-to-show": _vm.isPopupListAccountsToConnectDisplayed,
      "structure": _vm.selectedStructure,
      "accounts": _vm.flatUsers(_vm.selectedStructure)
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateListAccountsPopup(false);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex flex-col mt-16 mb-16"
  }, [_c('div', {
    staticClass: "-my-2 py-2"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('h3', {
    staticClass: "mt-15 mb-10 lg:mb-15 w-full"
  }, [_vm._v("\n            Abonnements\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "text-2xl inline-block hover:text-pink-600 font-light",
    class: {
      'text-indigo-600 font-normal': _vm.tabDisplay == 'structures'
    },
    on: {
      "click": function ($event) {
        return _vm.changeTab('structures');
      }
    }
  }, [_vm._v("\n              Structures\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-2xl inline-block sm:ml-5 xl:ml-10 hover:text-pink-600 font-light",
    class: {
      'text-indigo-600 font-normal': _vm.tabDisplay == 'particuliers'
    },
    on: {
      "click": function ($event) {
        return _vm.changeTab('particuliers');
      }
    }
  }, [_vm._v("\n              Particuliers\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex content-center items-center justify-between my-15 2xl:my-20 m-5 lg:mx-15 2xl:mx-20"
  }, [_c('div', {
    staticClass: "relative w-full sm:w-1/4 text-gray-400 focus-within:text-gray-600 border border-gray-200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "block w-full px-4 py-3 2xl:px-5 2xl:py-4 shadow-md rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 text-sm",
    attrs: {
      "id": "search_field",
      "placeholder": 'Rechercher ' + (_vm.tabDisplay === 'structures' ? 'une structure' : 'un particulier'),
      "type": "search"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.search,
      expression: "!search"
    }],
    staticClass: "absolute mr-2 inset-y-0 right-0 flex items-center pointer-events-none text-indigo-600"
  }, [_c('icon', {
    staticClass: "h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5",
    attrs: {
      "name": "search"
    }
  })], 1)]), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "is-checkbox-right": true,
      "value": _vm.showInactive,
      "libelle": "Afficher les comptes inactifs",
      "name": "inactiveAccounts"
    },
    on: {
      "input": function (newValue) {
        _vm.showInactive = newValue;
      }
    }
  }), _vm._v(" "), _c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        _vm.sort = sortType;
      }
    }
  })], 1), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('list-grid', {
    attrs: {
      "list-items": _vm.subscriptions,
      "is-accordion-items": "",
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-span-6 ml-15"
        }, [_vm._v("\n                Type d'abonnement\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-6"
        }, [_vm._v("\n                Nombre de structures\n              ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-span-6 ml-15"
        }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-6"
        }, [_vm._v("\n                " + _vm._s(_vm.structuresSort.filter(function (s) {
          return s.subscription === item;
        }).length) + "\n              ")])];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('list-grid', {
          attrs: {
            "list-items": _vm.structuresSort.filter(function (s) {
              return _vm.tabDisplay === 'structures' && s.subscription === item;
            }),
            "is-accordion-items": "",
            "grid": "grid-cols-10 border-l-2 border-indigo-600"
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function () {
              return [_c('div', {
                staticClass: "ml-16",
                class: {
                  'col-span-2': _vm.tabDisplay === 'structures',
                  'col-span-8': _vm.tabDisplay === 'particuliers'
                }
              }, [_vm._v("\n                    Nom\n                  ")]), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
                staticClass: "col-span-3 xl:col-span-2"
              }, [_vm._v("\n                    Administrateur\n                  ")]) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
                staticClass: "col-span-2"
              }, [_vm._v("\n                    Référents/Bénéficiaires\n                  ")]) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
                staticClass: "col-span-2"
              }, [_vm._v("\n                    Date expiration\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', {
                staticClass: "col-span-2"
              }, [_vm._v("\n                    Actions\n                  ")])];
            },
            proxy: true
          }, {
            key: "accordionDescription",
            fn: function (_ref3) {
              var _structure$users$mana, _structure$users, _structure$users$mana2, _structure$users$bene, _structure$users2, _structure$users2$ben;
              var structure = _ref3.item,
                index = _ref3.num;
              return [_c('div', {
                staticClass: "ml-16 col-span-2"
              }, [_c('p', {
                staticClass: "text-base"
              }, [_vm._v("\n                      " + _vm._s(structure.name) + "\n                      "), _c('span', {
                staticClass: "text-pink-600"
              }, [_vm._v("\n                        " + _vm._s(new Date(structure.expiry_date) <= new Date() ? ' (Inactif)' : '') + "\n                      ")])]), _vm._v(" "), _c('p', {
                staticClass: "text-sm text-gray-600"
              }, [_vm._v("\n                      Créé le\n                      " + _vm._s(new Date(structure.created_at).toLocaleDateString('fr')) + "\n                    ")])]), _vm._v(" "), _c('div', {
                staticClass: "col-span-3 xl:col-span-2"
              }, [_c('p', {
                staticClass: "text-base"
              }, [_vm._v("\n                      " + _vm._s(structure.admin ? structure.admin.firstname : 'Inconnu') + "\n                      " + _vm._s(structure.admin ? structure.admin.lastname : 'Inconnu') + "\n                    ")]), _vm._v(" "), _c('p', {
                staticClass: "text-sm text-gray-600"
              }, [_vm._v("\n                      " + _vm._s(structure.admin ? structure.admin.email : 'Inconnu') + "\n                    ")])]), _vm._v(" "), _c('div', {
                staticClass: "col-span-2"
              }, [_vm._v("\n                    " + _vm._s(((_structure$users$mana = (_structure$users = structure.users) === null || _structure$users === void 0 ? void 0 : (_structure$users$mana2 = _structure$users.manager) === null || _structure$users$mana2 === void 0 ? void 0 : _structure$users$mana2.length) !== null && _structure$users$mana !== void 0 ? _structure$users$mana : '0') + '/' + ((_structure$users$bene = (_structure$users2 = structure.users) === null || _structure$users2 === void 0 ? void 0 : (_structure$users2$ben = _structure$users2.beneficiary) === null || _structure$users2$ben === void 0 ? void 0 : _structure$users2$ben.length) !== null && _structure$users$bene !== void 0 ? _structure$users$bene : '0')) + "\n                  ")]), _vm._v(" "), _c('div', {
                staticClass: "col-span-2"
              }, [_vm._v("\n                    " + _vm._s(structure.expiry_date === null ? '' : new Date(structure.expiry_date).toLocaleDateString('fr')) + "\n                  ")]), _vm._v(" "), _c('div', {
                staticClass: "col-span-2 flex space-x-1"
              }, [_c('circle-button', {
                attrs: {
                  "icon": "monitor",
                  "label": "Accéder à l'interface Neopass de la structure"
                },
                on: {
                  "buttonClick": function ($event) {
                    return _vm.changeStateListAccountsPopup(true, structure);
                  }
                }
              })], 1)];
            }
          }, {
            key: "accordionContent",
            fn: function (_ref4) {
              var structure = _ref4.item,
                num = _ref4.num;
              return [_c('pre', [_vm._v(_vm._s(structure))])];
            }
          }], null, true)
        })];
      }
    }], null, false, 1489812997)
  }) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'particuliers' && _vm.particuliers.length === 0 ? _c('div', {
    staticClass: "flex items-center justify-center w-full"
  }, [_c('span', {
    staticClass: "w-5 h-5 rounded-full border-t-2 border-r animate-spin border-gray-600"
  })]) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'particuliers' && _vm.particuliers.length > 0 ? _c('div', {
    staticClass: "h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-10 gap-x-4 place-content-center mt-10"
  }, [_c('div', {
    staticClass: "ml-15",
    class: {
      'col-span-2': _vm.tabDisplay === 'structures',
      'col-span-8': _vm.tabDisplay === 'particuliers'
    }
  }, [_vm._v("\n              Nom\n            ")]), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
    staticClass: "col-span-3 xl:col-span-2"
  }, [_vm._v("\n              Administrateur\n            ")]) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n              Type d'abonnement\n            ")]) : _vm._e(), _vm._v(" "), _vm.tabDisplay === 'structures' ? _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n              Date expiration\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v("\n              Actions\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.particuliersSort.filter(function (s) {
    return _vm.tabDisplay === 'particuliers';
  }), function (particulier, idParticulier) {
    return _c('div', {
      key: 'particulier' + idParticulier,
      staticClass: "h-16 lg:h-24 2xl:h-32 text-base bg-white even:bg-gray-200 even:bg-opacity-50 grid grid-cols-10 gap-x-4 place-content-center items-center"
    }, [_c('div', {
      staticClass: "col-span-8 ml-15"
    }, [_c('p', {
      staticClass: "text-base"
    }, [_vm._v("\n                " + _vm._s(particulier.firstname) + " " + _vm._s(particulier.lastname) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "text-sm text-gray-600"
    }, [_vm._v("\n                Créé le\n                " + _vm._s(new Date(particulier.created_at).toLocaleDateString('fr')) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2"
    }, [_c('circle-button', {
      attrs: {
        "icon": "monitor",
        "label": "Accéder à l'interface Neopass du particulier"
      },
      on: {
        "buttonClick": function ($event) {
          return _vm.connectToAccount(particulier);
        }
      }
    })], 1)]);
  })], 2)])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Administration des abonnements\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Cras ultricies ligula sed magna dictum porta. Vestibulum ac diam sit\n        amet quam vehicula elementum sed sit amet dui. Vivamus magna justo,\n        lacinia eget consectetur sed, convallis at tellus.\n      ")])]);

}]

export { render, staticRenderFns }